<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="!uploading"
    [dismissableMask]="!uploading"
    [style]="{width: '70vw', height: '60vh', maxWidth: '1200px', maxHeight: '800px'}"
    styleClass="p-fluid carica-documenti-rendicontazione-dialog"
    [showHeader]="false"
    (onHide)="hide()">

    <div class="dialog-container">
        <div class="dialog-header">
            <div class="header-content">
                <i class="pi pi-upload header-icon"></i>
                <h3>Carica nuovi allegati per {{ rendicontazione?.tipo?.descrizione === 'ACCONTO' ? 'l\'' : 'il ' }}{{ rendicontazione?.tipo?.descrizione | uppercase }} dell'intervento</h3>
                <div *ngIf="intervento?.scheda?.vecchioCodiceUmvs" class="code-badge legacy-code" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #8f5cb7;">
                  <span class="code-value" style="font-weight: bold; color: #8B4513; " pTooltip="VECCHIO CODICE UMVS" tooltipPosition="top">{{ intervento?.scheda?.vecchioCodiceUmvs }}</span>
                 </div>
                 <div class="code-badge" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #4285F4;">
                   <span class="code-value" style="font-weight: bold; color: #3a6e75;" pTooltip="NUOVO CODICE" tooltipPosition="top">{{ intervento?.scheda?.codice }}</span>
                 </div>
            </div>
            <button
                pButton
                pRipple
                icon="pi pi-times"
                class="p-button-rounded p-button-text close-btn"
                [disabled]="uploading"
                (click)="hide()">
            </button>
        </div>

        <div class="dialog-content">
           <!--  <div class="info-section" *ngIf="rendicontazione && intervento">
                <p><strong>Tipo Rendicontazione:</strong> {{ rendicontazione.tipo.descrizione }}</p>
                <p><strong>Importo:</strong> {{ rendicontazione.importo | currency:'EUR' }}</p>
            </div>

            <div class="error-section" *ngIf="!rendicontazione || !intervento">
                <p style="color: #dc3545; text-align: center;">
                    <i class="pi pi-exclamation-triangle" style="margin-right: 0.5rem;"></i>
                    Dati non disponibili per il caricamento documenti
                </p>
            </div> -->

            <div class="field">
                <label for="fileUpload">Seleziona File da Caricare</label>
                <p-fileUpload
                    id="fileUpload"
                    mode="advanced"
                    [multiple]="true"
                    accept=".pdf,.p7m"
                    [maxFileSize]="10000000"
                    chooseLabel="Scegli File"
                    uploadLabel="Carica"
                    cancelLabel="Annulla"
                    (onSelect)="onFileSelect($event)"
                    (onClear)="onFileClear($event)"
                    (onRemove)="onFileRemove($event)"
                    [auto]="false"
                    [showUploadButton]="false"
                    [showCancelButton]="false"
                    [disabled]="uploading || !rendicontazione || !intervento">
                </p-fileUpload>
            </div>

                        <div class="field">
              <!--   <label>File Selezionati ({{ selectedFiles.length }})</label>


                <div class="file-list" *ngIf="selectedFiles.length > 0">
                    <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
                        <div class="file-info">
                            <i class="pi pi-file" style="margin-right: 0.5rem;"></i>
                            <span class="file-name">{{ file.name }}</span>
                            <span class="file-size">({{ formatFileSize(file.size) }})</span>
                        </div>
                        <button
                            pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-text p-button-danger p-button-sm"
                            (click)="removeFile(file)"
                            [disabled]="uploading">
                        </button>
                    </div>
                </div> -->

                <!-- <div class="file-summary" *ngIf="selectedFiles.length > 0">
                    <p><strong>Totale file:</strong> {{ selectedFiles.length }}</p>
                    <p><strong>Dimensione totale:</strong> {{ formatFileSize(getTotalFileSize()) }}</p>
                </div>

                <div class="no-files" *ngIf="selectedFiles.length === 0">
                    <p style="color: #6c757d; text-align: center; font-style: italic;">
                        <i class="pi pi-info-circle" style="margin-right: 0.5rem;"></i>
                        Nessun file selezionato. Usa il selettore file sopra per scegliere i documenti da caricare.
                    </p>
                </div> -->
            </div>

            <div class="field" *ngIf="uploading">
                <label>Progresso Upload</label>
                <div class="progress-container">
                    <div class="progress-bar">
                        <div class="progress-fill" [style.width.%]="uploadProgress"></div>
                    </div>
                    <span class="progress-text">{{ uploadProgress | number:'1.0-0' }}%</span>
                </div>
            </div>
        </div>

        <div class="dialog-footer">
            <button
                pButton
                pRipple
                label="Annulla"
                icon="pi pi-times"
                class="p-button-outlined p-button-secondary"
                (click)="hide()"
                [disabled]="uploading">
            </button>
            <button
                pButton
                pRipple
                [label]="uploading ? '' : 'Carica File'"
                [icon]="uploading ? '' : 'pi pi-upload'"
                class="p-button-success"
                (click)="uploadSelectedFiles()"
                [disabled]="!isFormValid() || uploading"
                [pTooltip]="!rendicontazione || !intervento ? 'Dati non disponibili' : ''"
                tooltipPosition="top">
                <ng-container *ngIf="uploading">
                    <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>
                    Caricamento...
                </ng-container>
            </button>
        </div>
    </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
